import { render, staticRenderFns } from "./TabelaProdutos.vue?vue&type=template&id=214c7371&scoped=true&"
import script from "./TabelaProdutos.vue?vue&type=script&lang=js&"
export * from "./TabelaProdutos.vue?vue&type=script&lang=js&"
import style0 from "./TabelaProdutos.vue?vue&type=style&index=0&id=214c7371&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214c7371",
  null
  
)

export default component.exports